import { deleteDataAsync, getDataAsync, postDataAsync, putDataAsync } from "../ZeosApiExecutor";
import {
  IAdminIncentiveProgramRequest,
  IAdminIncentiveProgramResponse,
  IAdminIncentivePublishRequest,
  IIncentiveAdminDiagnosticsResponse,
  IIncentiveReferenceResponse,
  IIncentiveResearchRequest,
  IIncentiveResearchResponse,
} from "../contracts/IncentiveAdmin";
import { IIncentiveAdmin } from "./interfaces/IIncentiveAdmin";

const incentiveAdminPrefix = "/Admin/Incentives";

export const IncentiveAdmin: IIncentiveAdmin = {
  getProgramsAsync: async (includeDrafts: boolean, includeArchived = false) => {
    const response = await getDataAsync<IAdminIncentiveProgramResponse[]>(
      `${incentiveAdminPrefix}?includeDrafts=${includeDrafts}&includeArchived=${includeArchived}`,
      ""
    );
    return response;
  },
  upsertProgramAsync: async (request: IAdminIncentiveProgramRequest) => {
    const response = await postDataAsync<IAdminIncentiveProgramResponse>(
      incentiveAdminPrefix,
      request
    );
    return response;
  },
  setPublishedAsync: async (
    incentiveProgramId: number,
    request: IAdminIncentivePublishRequest
  ) => {
    const response = await putDataAsync<IAdminIncentiveProgramResponse>(
      `${incentiveAdminPrefix}/${incentiveProgramId}/publish`,
      request
    );
    return response;
  },
  deleteProgramAsync: async (incentiveProgramId: number) => {
    const response = await deleteDataAsync<boolean>(
      `${incentiveAdminPrefix}/${incentiveProgramId}`,
      null
    );
    return response;
  },
  restoreProgramAsync: async (incentiveProgramId: number) => {
    const response = await putDataAsync<IAdminIncentiveProgramResponse>(
      `${incentiveAdminPrefix}/${incentiveProgramId}/restore`,
      {}
    );
    return response;
  },
  getReferencesAsync: async () => {
    const response = await getDataAsync<IIncentiveReferenceResponse>(
      `${incentiveAdminPrefix}/References`,
      ""
    );
    return response;
  },
  getDiagnosticsAsync: async () => {
    const response = await getDataAsync<IIncentiveAdminDiagnosticsResponse>(
      `${incentiveAdminPrefix}/Diagnostics`,
      ""
    );
    return response;
  },
  researchAsync: async (request: IIncentiveResearchRequest, limit?: number) => {
    const query = limit ? `?limit=${limit}` : "";
    const response = await postDataAsync<IIncentiveResearchResponse>(
      `${incentiveAdminPrefix}/Research${query}`,
      request
    );
    return response;
  },
};
